import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "name",
    standalone: true
})
export class FileNamePipe implements PipeTransform {
    transform(value: string): string {
        const urlParts = value.toString().split('/');
        const fileName = urlParts[urlParts.length - 1];
        return fileName ? fileName : 'Unknown file';
    }
}